(function () {
    "use strict";

    angular.module("app").factory("HabilNavigator", HabilNavigatorFactory);

    HabilNavigatorFactory.$inject = ["$window", "settingsService", "guid"];
    function HabilNavigatorFactory($window, settingsService, guid) {
        const kboBaseUrl = 'http://kbopub.economie.fgov.be/kbopub/';

        return {
            GoToDashboard: goToDashboard,
            ReturnToPreviousPage: ReturnToPreviousPage,
            OpenUrl: openUrl,
            OpenUrlInTab: openUrlInTab,
            BuildUrl: buildUrl,
            BuildRelativeUrl: buildRelativeUrl,
            OpenRoute: openRoute,
            OpenByIdAndRoute: openByIdAndRoute,
            OpenRouteInTab: openRouteInTab,
            OpenKboSearchNumberInTab: openKboSearchNumberInTab,
            OpenKboSearchNameInTab: openKboSearchNameInTab,
            GetRouteBuilder: (routeBase) => new RouteBuilder(routeBase),
            CurrentPage: $window.location.pathname + $window.location.search
        };

        function goToDashboard() {
            openUrl(settingsService.GetBaseUrl());
        }

        function ReturnToPreviousPage() {
            if ($window.history.length > 1) {
                $window.history.go(-1);
            }
            else {
                goToDashboard();
            }
        }

        /**
         * Opens the provided URL in the current window/tab
         * @param {String} url The target URL
         */
        function openUrl(url) {
            if (!url)
                return;

            try {
                $window.location.href = url;
            } catch (error) {
                console.error(error);
            }
        }

        /**
         * Opens the provided URL in a new window/tab
         * @param {String} url The target URL
         */
        function openUrlInTab(url) {
            if (!url)
                return;

            try {
                $window.open(url, "_blank");
            } catch (error) {
                console.error(error);
            }
        }

        /**
         * @param {String} baseUrl The URL
         * @param {String} parameter Optional parameter
         * @param {String} escaped Flag determining whether the parameter needs to be encoded
         * @returns The URL
         */
        function buildUrl(baseUrl, parameter, escaped) {
            if (!parameter || !baseUrl) {
                console.error("HabilNavigator.BuildURL: Invalid parameters (baseUrl or parameter) provided");
                return '';
            }

            const sanitized = escaped ? encodeURIComponent(parameter) : parameter;

            return `${baseUrl}${sanitized}`;
        }

        /**
         * @param {String} baseUrl The URL
         * @param {String} parameter Optional parameter
         * @param {String} escaped Flag determining whether the parameter needs to be encoded
         * @returns The URL
         */
        function buildRelativeUrl(baseUrl, parameter, escaped) {
            if (!parameter || !baseUrl) {
                console.error("HabilNavigator.BuildRelativeURL: Invalid parameters (baseUrl or parameter) provided");
                return '';
            }

            return buildUrl(settingsService.applicationPath + baseUrl, parameter, escaped);
        }

        /**
         * Opens an app dependent route
         * @param {any} route
         */
        function openRoute(route, replaceHistory = false) {
            const url = `${settingsService.GetBaseUrl()}${route}`;
            if (replaceHistory === true) {
                $window.location.replace(url);
            }
            else
                openUrl(url);
        }

        /**
         * Open app dependent route in new tab
         * @param {any} route
         */
        function openRouteInTab(route) {
            openUrlInTab(`${settingsService.GetBaseUrl()}${route}`);
        }

        function openByIdAndRoute(id, route, openInNewTab = false) {
            if (guid.isEmpty(id) || !guid.validate(id))
                return;
            
            const frontPath = `${settingsService.GetBaseUrl()}`;
            const url = buildUrl(frontPath + route, id, true);
            if (!openInNewTab)
                openUrl(url);
            else
                openUrlInTab(url);
        }

        function openKboSearchNumberInTab(kboNumber) {
            openUrlInTab(`${kboBaseUrl}zoeknummerform.html?nummer=${kboNumber}`);
        }

        function openKboSearchNameInTab() {
            openUrlInTab(`${kboBaseUrl}zoeknaamfonetischform.html`);
        }

        function RouteBuilder(routeBase) {
            const self = this;
            let route = routeBase;

            self.AddParameter = function (key, value) {
                const normalized = value || "";
                route += `${key}=${normalized}&`;
                return self;
            };

            self.GetRoute = function () {
                return route;
            };
        }
    }
})();
